import { render, staticRenderFns } from "./ConfigTeamTab.vue?vue&type=template&id=505edb59&scoped=true"
import script from "./ConfigTeamTab.vue?vue&type=script&lang=js"
export * from "./ConfigTeamTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigTeamTab.vue?vue&type=style&index=0&id=505edb59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505edb59",
  null
  
)

export default component.exports